export default __webpack_public_path__ + "static/media/Labirynth-03.e946ea62.svg";